var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.value.url
    ? _c(
        "div",
        { staticClass: "md-style-scoped" },
        [
          _c(
            "md-field",
            [
              _c("label", { attrs: { for: _vm.$props.id } }, [
                _vm._v(_vm._s(_vm.t("app-logo"))),
              ]),
              _vm._v(" "),
              _c("md-file", {
                attrs: { id: _vm.$props.id, accept: ".png, .jpeg, .jpg" },
                on: { change: _vm.changed },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _c("div", { staticClass: "logo-row" }, [
        _c("img", { attrs: { src: _vm.value.url.href } }),
        _vm._v(" "),
        _c(
          "div",
          { on: { click: _vm.remove } },
          [_c("md-icon", { staticClass: "remove-button" }, [_vm._v("close")])],
          1
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }